import { useEffect, useState } from "react";
import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewInternalAccountDetail } from "../../../redux/features/internalApi/internalApi";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import ICONS from "../../../assets/Icons";

const InternalAccEditSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { id } = useParams();

  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    category: "",
    id: "",
    pan_no: "",
    bank_account_holder_full_name: "",
  });

  const { viewInternalAccountDetailData } = useSelector(
    (state) => state.internalAcc,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const safeServices = Array.isArray(services) ? services : [];

  const updatedFields = location?.state?.updatedFields || [];

  const contactFieldConfig = {
    account_name: {
      leftSubTitle: "Account name",
      getTitle: (acc) =>
        acc?.name ? accountNameStandardised(acc.name) : "Not available",
    },
    contact_no: {
      leftSubTitle: "Contact number",
      icon: ICONS.CONTACT_NO,
      getTitle: (acc) =>
        acc?.contact_no ? `+91 ${acc.contact_no}` : "Not available",
    },
    email_id: {
      leftSubTitle: "Email ID",
      icon: ICONS.GMAIL_RED_ERROR,
      getTitle: (acc) => acc?.email_id || "Not available",
    },
  };

  const getFieldsToShow = () => {
    if (updatedFields.length > GlobalConfiguration.lengthCheckZero) {
      return updatedFields;
    }

    return ["account_name", "contact_no", "email_id"];
  };

  const fieldsToShow = getFieldsToShow();
  const showOnlyUpdated = fieldsToShow;

  const renderInfoCards = () => {
    return fieldsToShow
      .filter((key) => contactFieldConfig[key])
      .map((key) => {
        const config = contactFieldConfig[key];
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: config.getTitle(accountData),
                leftSubTitle: config.leftSubTitle,
                ...(config.icon && { icon: config.icon }),
              },
            ]}
          />
        );
      });
  };

  const createAccountHandler = () => {
    navigate("/internal_transaction_dashboard/create_internal_transaction", {
      state: currentAccountDetails,
    });
  };

  const viewDetailsHandler = () => {
    navigate(
      `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${id}`,
    );
  };

  const dashboardHandler = () => {
    navigate("/internal_account_dashboard");
  };

  const accountData = viewInternalAccountDetailData?.internal_accounts[0] || {};

  useEffect(() => {
    dispatch(viewInternalAccountDetail({ id: id }));
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (accountData) {
      const {
        bank_name,
        bank_acc_no,
        category,
        ifsc_code,
        id,
        pan_no,
        bank_account_holder_full_name,
        name,
      } = accountData;
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category,
        ifsc_code,
        id,
        pan_no,
        bank_account_holder_full_name,
        name,
      });
    }
  }, [accountData]);

  const buttonRows = [
    [
      ...(safeServices.includes("CInternalTxn")
        ? [
            {
              btnText: "Create transaction",
              enabledBgColor: "var(--text-primary)",
              enabledTextColor: "var(--positive-bg)",
              icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
              handleFunction: createAccountHandler,
              iconToBeAlign: "left",
              fullWidthRequired: true,
              imgColor: "var(--positive-bg)",
            },
          ]
        : []),

      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        hoverOption: "white",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];
  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={"Details updated successfully."}
      >
        <TabsWeapperSection title="Account details">
          <>{showOnlyUpdated ? renderInfoCards() : <></>}</>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default InternalAccEditSuccess;
